// extracted by mini-css-extract-plugin
export default {"productCarousel":"l1-z"};